import { render } from "./SubscriptionSettingsModal.vue?vue&type=template&id=a2a8f638"
import script from "./SubscriptionSettingsModal.vue?vue&type=script&lang=js"
export * from "./SubscriptionSettingsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__